import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconEditSquare(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M10.5 1.5H1.5V10.5H10.5V1.5Z" stroke="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4004 0.891373L6.20098 5.09112L5.49388 4.38401L9.69021 0.18137L10.4004 0.891373Z"
        fill="#FAFAFA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8575 0.848668L6.90779 5.79842L6.20068 5.09131L11.1504 0.141561L11.8575 0.848668Z"
        fill="currentColor"
      />
      <path
        d="M6.55435 6.15186L5.59609 6.52683C5.56073 6.54066 5.52054 6.53226 5.49369 6.50541C5.46684 6.47856 5.45844 6.43837 5.47227 6.40301L5.84724 5.44475L6.55435 6.15186Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
